import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Hero from "@/components/site/Hero";
import RateStrip from "@/components/site/RateStrip";
import ProductWall from "@/components/site/ProductWall";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import SpecSheet from "@/components/site/SpecSheet";
import WhyUs from "@/components/site/WhyUs";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyCta from "@/components/site/StickyCta";

export default function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.1 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="site" data-testid="site-root">
      <Hero />
      <RateStrip />
      <ProductWall />
      <EditorialMarquee />
      <SpecSheet />
      <WhyUs />
      <Contact />
      <Footer />
      <StickyCta />
    </div>
  );
}
